import React from 'react';

import AddIcon from '@atlaskit/icon/core/add';
import AutomationIcon from '@atlaskit/icon/core/automation';
import CommentIcon from '@atlaskit/icon/core/comment';
import DeleteIcon from '@atlaskit/icon/core/delete';
import EditIcon from '@atlaskit/icon/core/edit';
// import EpicIcon from '@atlaskit/icon/core/epic';
import PageIcon from '@atlaskit/icon/core/page';
import PersonIcon from '@atlaskit/icon/core/person';
import SprintIcon from '@atlaskit/icon/core/sprint';
import TransitionIcon from '@atlaskit/icon/core/transition';
import WorkItemIcon from '@atlaskit/icon/core/work-item';

export const getAgentActionIcon = (actionKey: string): React.JSX.Element => {
	switch (actionKey) {
		case 'agent_action_jira_issue_create':
			return <AddIcon label="" color="var(--ds-icon-brand)" />;
		case 'agent_action_confluence_page_create':
			return <PageIcon label="" color="var(--ds-icon-brand)" />;
		case 'agent_action_jira_issue_comment':
			return <CommentIcon label="" color="var(--ds-icon-brand)" />;
		case 'agent_action_confluence_page_comment':
			return <CommentIcon label="" color="var(--ds-icon-brand)" />;
		case 'agent_action_jira_issue_move':
			return <SprintIcon label="" color="var(--ds-icon-brand)" />;
		case 'agent_action_jira_issue_delete':
			return <DeleteIcon label="" color="var(--ds-icon-brand)" />;
		case 'agent_action_jira_issue_assign':
			return <PersonIcon label="" color="var(--ds-icon-brand)" />;
		case 'agent_action_jira_issue_edit':
			return <EditIcon label="" color="var(--ds-icon-brand)" />;
		case 'agent_action_jira_issue_transition':
			return <TransitionIcon label="" color="var(--ds-icon-brand)" />;
		case 'agent_action_jira_epics_suggest':
			return <WorkItemIcon label="" color="var(--ds-icon-brand)" />;
		default:
			return <AutomationIcon label="" color="var(--ds-icon-brand)" />;
	}
};
